import { Button as ButtonNextUI, ButtonProps, cn } from '@nextui-org/react';

const Button = ({ children, className, ...props }: ButtonProps) => {
  return (
    <ButtonNextUI
      size='md'
      radius='sm'
      className={cn('bg-white text-fg-secondary border border-borderPrimary hover:border-secondary', className)}
      {...props}
    >
      {children}
    </ButtonNextUI>
  );
};

export default Button;
